import { useSyncExternalStore } from 'react';
import cabinetStore from '../store/cabinetStore';

export function useCabinetStore() {
  const state = useSyncExternalStore(
    cabinetStore.subscribe,
    cabinetStore.getSnapshot,
  );

  return {
    ...state,
    setExpandedMenu: cabinetStore.setExpandedMenu,
    setAddFlowExpanded: cabinetStore.setAddFlowExpanded,
    toggleAddFlow: cabinetStore.toggleAddFlow,
  };
}
